import i18n from '../../i18n';
import { RefreshCw } from 'lucide-react';
import { useState, useEffect } from 'react';

const DashboardHeader = ({ t, refreshing, fetchDashboardData }) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  const locale = i18n.language === 'ar' ? 'ar-TN' : i18n.language === 'en' ? 'en-GB' : 'fr-FR';

  const datePart = now.toLocaleDateString(locale, {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  });

  const timePart = now.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });

  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div>
        <h1 className="font-semibold mb-1"
          style={{ color: "var(--lm-ink)", letterSpacing: "-0.6px", fontSize: "26px", lineHeight: "1.2" }}>
          {t('dashboard.title')}
        </h1>
        <p className="text-sm" style={{ color: "var(--lm-ink-3)" }}>
          <span style={{ color: "var(--lm-ink-2)" }}>{datePart}</span>
          <span style={{ color: "var(--lm-border-2)", margin: "0 6px" }}>•</span>
          <span style={{ fontVariantNumeric: "tabular-nums" }}>{timePart}</span>
        </p>
      </div>
      <button
        onClick={fetchDashboardData}
        disabled={refreshing}
        aria-label={refreshing ? t('common.loading') : t('common.refresh')}
        className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-medium transition-colors self-start lg:self-auto focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-[#5e6ad2]"
        style={{ backgroundColor: refreshing ? "var(--lm-s2)" : "#5e6ad2", color: refreshing ? "var(--lm-ink-2)" : "#fff", border: refreshing ? "1px solid var(--lm-border)" : "none" }}
        onMouseEnter={e => { if (!refreshing) e.currentTarget.style.backgroundColor = "#828fff"; }}
        onMouseLeave={e => { e.currentTarget.style.backgroundColor = refreshing ? "var(--lm-s2)" : "#5e6ad2"; }}
      >
        <RefreshCw className={`w-3.5 h-3.5 ${refreshing ? 'animate-spin' : ''}`} />
        {refreshing ? t('common.loading') : t('common.refresh')}
      </button>
    </div>
  );
};

export default DashboardHeader;
